import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Col, Container, Row } from "reactstrap";
import Navbar from "../../Landing/ForecastNestHome/navbar";
import Footer from "../../Landing/ForecastNestHome/footer";
import ContactForm from "../../Landing/ForecastNestHome/contact";
import ResearchDisclaimer from "../../../Components/Common/ResearchDisclaimer";

/*
 * Contact on a page of its own.
 *
 * The form already existed, but only as a section of the landing page, reachable
 * by an anchor. Anyone reading the privacy policy, the terms or the refund
 * policy had no way to get to it — and "can a visitor find how to reach you from
 * any page" is one of the things a merchant of record checks before switching on
 * a checkout.
 *
 * The same component, wrapped in the reCAPTCHA provider it needs, which on the
 * landing page is supplied around the section there.
 */

const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY || "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI";

const ContactUs = () => {
  document.title = "Contact | ForecastNest";

  return (
    <React.Fragment>
      <div className="layout-wrapper landing">
        <Navbar />
        {/* An explicit offset rather than "section pt-5 mt-5".
            That combination looks like 90 + 48 + 48 and is worth 48: Bootstrap's
            spacing utilities are !important, so pt-5 REPLACES .section's 90px
            top padding with 3rem, and the mt-5 margin collapses out of
            layout-wrapper, which has no padding or border to contain it. 48px
            is less than the fixed navbar, so the heading sat under the bar.

            The policy pages carry the same shortfall; it just does not show
            there, because their first element is a Card whose own padding
            pushes the text clear. */}
        <div style={{ paddingTop: 110 }}>
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <div className="text-center mb-4">
                  <h4 className="mb-2">Get in touch</h4>
                  <p className="text-muted mb-0">
                    Questions about the service, your account, a refund, or your data —
                    this reaches us directly. You can also email{" "}
                    <a href="mailto:support@forecastnest.com">support@forecastnest.com</a>.
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* The page has already introduced itself above; the section's own
            heading would be the second "Get in touch" in a row. */}
        <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
          <ContactForm showHeading={false} />
        </GoogleReCaptchaProvider>

        <Container>
          <Row className="justify-content-center">
            <Col lg={9}>
              <ResearchDisclaimer className="text-center mb-4" />
            </Col>
          </Row>
        </Container>

        <Footer />
      </div>
    </React.Fragment>
  );
};

export default ContactUs;
